import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import la from "./locales/la.json";
import "./App.css";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    la: { translation: la },
  },
  lng: localStorage.getItem("language") || "en",
  fallbackLng: "en",
  interpolation: { escapeValue: true },
});

export default i18n;
